import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../../components/EnrollmentModal'

export function WestAfrica() {
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600">EMR</Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="bg-gradient-to-br from-yellow-50 via-white to-green-50 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-6xl mb-6">🌍</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            EMR for <span className="text-yellow-600">West Africa</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Built for the diverse healthcare landscape of West Africa. Portable, offline-capable,
            and designed for resource-constrained environments across Ghana, Senegal, Côte d'Ivoire, and beyond.
          </p>
          <button
            onClick={() => setEnrollmentModalOpen(true)}
            className="bg-yellow-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-700 transition"
          >
            Start Free Trial
          </button>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">West African Healthcare Features</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🔋</div>
              <h3 className="text-xl font-semibold mb-2">Portable EMR</h3>
              <p className="text-gray-600">
                Raspberry Pi-based portable solution. Battery/solar powered, under $100 hardware cost.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">☁️</div>
              <h3 className="text-xl font-semibold mb-2">100% Offline</h3>
              <p className="text-gray-600">
                Complete offline functionality with conflict resolution and intelligent sync when connected.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🌐</div>
              <h3 className="text-xl font-semibold mb-2">Multi-Language</h3>
              <p className="text-gray-600">
                French, English, Portuguese, Wolof, Twi, and local languages for patient engagement.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">💰</div>
              <h3 className="text-xl font-semibold mb-2">Multi-Currency</h3>
              <p className="text-gray-600">
                Support for CFA Franc, Cedi, Naira, and other regional currencies with local payment methods.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">📶</div>
              <h3 className="text-xl font-semibold mb-2">Low Bandwidth</h3>
              <p className="text-gray-600">
                Optimized for 2G/3G networks with compressed sync and progressive data loading.
              </p>
            </div>
            <div className="p-6 border rounded-lg">
              <div className="text-3xl mb-4">🏥</div>
              <h3 className="text-xl font-semibold mb-2">Community Health</h3>
              <p className="text-gray-600">
                Tools for community health workers, mobile clinics, and outreach programs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Countries */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Serving West Africa</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {['🇬🇭 Ghana', '🇸🇳 Senegal', "🇨🇮 Côte d'Ivoire", '🇲🇱 Mali', '🇧🇫 Burkina Faso', '🇳🇪 Niger', '🇬🇳 Guinea', '🇹🇬 Togo', '🇧🇯 Benin', '🇸🇱 Sierra Leone', '🇱🇷 Liberia', '🇬🇲 Gambia'].map((country) => (
              <span key={country} className="px-4 py-2 bg-white rounded-full border text-gray-700">
                {country}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-white hover:text-blue-400 transition">← Back to Home</Link>
          <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} EMR System. All rights reserved.</p>
        </div>
      </footer>

      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

